import { createContext } from "react";

const OverlayContext = createContext({
  id: 0,
  mapRef: null,
  mapReady: false,
  location: null,
  config: null,
  buses: null,
  pcs: null,
  laundry: null,
  outlets: null,
  markers: [],
  setMarkers: () => null,
  search: false,
});

export default OverlayContext;